import React, { useEffect, useState } from "react";
import SidebarNavigation from "../components/layout/sidebar-navigation";
import TopBarNavigation from "../components/layout/top-bar";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { Grid, Typography, CssBaseline } from "@mui/material";

import { Box } from "@mui/material";

import InnerTabs from "../components/layout/inner-tabs";

import productCategory from "../data/product-category.json";
import productItem from "../data/product-item.json";
import products from "../data/product.json";
// import { useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";

const Product = () => {
  const { id: productRef } = useParams();
  const { categoryId: categoryRef } = useParams();

  const product = products.filter((item) => item.ReferenceName == productRef);

  const productID = product[0].ID;

  const [productRefState, setProductRefState] = useState(productRef);

  const productCategoryList = productCategory.filter(
    (item) => item.ProductID == productID
  );
  

  // console.log(productID);

  const [value, setValue] = useState<string | undefined>(
    productCategoryList[0].ReferenceName
  );

  useEffect(() => {
    setValue(categoryRef ? categoryRef : productCategoryList[0].ReferenceName);
    setProductRefState(product[0].ReferenceName);
  }, [productID]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box ml={2} mt={8} sx={{ width: "100%" }}>
      <TabContext value={value || ""}>
        <Grid flexDirection={"column"} display={"flex"}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mr: "16px" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{ px: 0, mx: 0 }}
            >
              {productCategoryList.map((item, index) => (
                <Tab
                  sx={{ px: 2, mx: 0, minWidth: "55px" }}
                  label={item.Name}
                  value={item.ReferenceName}
                  disabled={!item.IsAvailable}
                  key={index}
                />
              ))}
            </TabList>
          </Box>
          <Box className="tab-inner-scroll">
            {productCategoryList.map((item, index) => (
              <TabPanel
                value={item.ReferenceName}
                sx={{ mt: "3px", m: "0px", p: "0px" }}
                key={index}
              >
                <InnerTabs
                  productCategoryID={item.ID}
                  productCategoryRef={item.ReferenceName}
                  productRef={productRefState}
                />
              </TabPanel>
            ))}
          </Box>
        </Grid>
      </TabContext>
    </Box>
  );
};

export default Product;
